<template>	
  <b-container fluid >          
    <b-row>
        <b-col>
            <b-tabs content-class="mt-3" class="mt-3">
                <b-tab title="PostPago" active>
                    <b-row align-h="center">
                        <!-- <b-col cols="12" class="mt-3 mb-2">
                            <h5 style="color: gray; text-transform:capitalize;"><b-icon icon="files"/> Pagos</h5>
                        </b-col>  -->

                        
                        <b-col cols="11" md="4">
                            <b-form-input placeholder="Código" v-model="codigoIUSA" size="sm"></b-form-input>
                        </b-col>
                        <b-col cols="11" md="4">
                            <b-form-input placeholder="Usuario" v-model="usuarioIUSA" size="sm"></b-form-input>
                        </b-col>
                        <b-col cols="11" md="4">
                            <b-form-input type="password" placeholder="Contraseña" v-model="passIUSA" size="sm"></b-form-input>
                        </b-col>

                        <b-col cols="11" md="12" class="mt-3 ">
                            <b-button v-if="!isSyncronizando" @click="getLiquidacionTarjeta"  block variant="warning">Leer Consumo Tarjeta</b-button>
                        </b-col>
                        <b-col cols="11" md="12" class="mt-3 "  >
                            <b-button :disabled="totalLiquidacion==null" @click="showConfirmacionCobro"  block variant="success">
                                <b-spinner v-if="isCobrando"></b-spinner>
                                <b-icon v-if="!isCobrando" icon="cash-stack"/>
                                <strong v-if="isCobrando"> Cobrando . . .</strong>
                                <strong v-if="!isCobrando"> Cobrar Consumo</strong>
                            </b-button>
                        </b-col>
                        
                        
                    </b-row>
                </b-tab>
                <b-tab title="Puntos Externos">
                    <b-row align-h="center">
                        <!-- <b-col cols="12" class="mt-3 mb-2">
                            <h5 style="color: gray; text-transform:capitalize;"><b-icon icon="files"/> Pagos</h5>
                        </b-col>  -->
                        
                        <b-col cols="11" md="12" class="mt-3 mb-3">
                            <b-button v-if="!isSyncronizando" @click="sincronizarPagosIusa" block variant="outline-secondary">Iniciar Sincronización Puntos Externos</b-button>
                            <b-button v-if="isSyncronizando" @click="isSyncronizando=false" block variant="warning">Cancelar <b-spinner small></b-spinner> </b-button>
                        </b-col>
                        <b-col cols="12" md="12" v-if="isSyncronizando">
                            <h5>{{estadoSyncIUSA}}</h5>
                            <b-form-textarea
                            v-model="resultadoSyncIUSA" rows="100" max-rows="100"
                            ></b-form-textarea>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>

            
        </b-col>
    </b-row>

    <b-modal hide-footer title="¿Desea continuar con el cobro?" v-model="isShowConfirmacionCobro"  header-bg-variant="dark" header-text-variant="light">
        <b-row align-h="center" align="center">
            <b-col>
                <b-button variant="success" @click="cobrarLiquidacionTarjeta">Si, Continuar</b-button>
            </b-col>
            <b-col>
                <b-button variant="secondary" @click="isShowConfirmacionCobro=false">No, Cancelar</b-button>
            </b-col>
        </b-row>
        <b-row class="mt-5 mb-3" align="center" align-h="center">
            <b-col class="mt-3" cols="12"><h5><b>Total a Cobrar: </b></h5><h5 style="color:red;"><b>$ {{totalLiquidacion}}</b></h5> </b-col>
            <b-col class="mt-3" cols="12"><h5><b>Recibido: </b></h5> </b-col>
            <b-col cols="12" md="10" lg="6"><b-form-input style="text-align: center;" autofocus :state="dineroRecibido!=null && dineroRecibido!=''" type="number" v-model="dineroRecibido" @input="calculaCambio"></b-form-input> </b-col>
            <b-col class="mt-3" cols="12"><h5><b>Cambio: </b></h5><h5 style="color:red;"><b>$ {{cambioDinero}}</b></h5> </b-col>

            <b-col cols="12">
                <b-form-input style="text-align: center;"  type="number" v-model="formaPagoIUSA" >
                </b-form-input> 
            </b-col>
        
        </b-row>
    </b-modal>
  </b-container>
</template>

<script>
    import { mapState} from 'vuex'
    import axios from 'axios'
    import { server, server2, getGetConfig, getPostConfig, handledError , checkAuth} from '@/axios-tools'
    import { navTo } from '@/vue-tools'
    
    export default {
        computed: mapState({
            parcialidades: state => state.cobro.parcialidades,
            totalLiquidacion: state => state.cobro.totalLiquidacion,
            token: state => state.login.token,
            datosPago: state => state.cobro.datosPago,
            isCobrando: state => state.cobro.isCobrando,
            catalogCobro: state => state.cobro.catalogCobro
            
            
        }),
        data(){
            return{

                /* Usados para integrar recibos IUSA */ 
                resultadoSyncIUSA:'',
                estadoSyncIUSA:'',
                isSyncronizando:false,
                isCalculando : false,
                isGenerando : false,

                //serverIUSA:'https://metering.autogestion.com.mx/Agua/Calimaya_Plus/WCF/Autogestion.svc',
                //codigoIUSA:'PRUEBA01',
                //usuarioIUSA:'SERGIO01',
                //passIUSA:'PRUEBAS',

                
                codigoIUSA:'',
                usuarioIUSA:'',
                passIUSA:'',

                totalAPagar:0,

                isShowConfirmacionCobro:false,
                dineroRecibido:"",
                cambioDinero:"",

                formaPagoIUSA:1
            }
        },
       
        methods: {
           
            sincronizarPagosIusa: function(){
                this.isSyncronizando = true;
                this.resultadoSyncIUSA = '';
                this.estadoSyncIUSA = '';
                axios(
                    getGetConfig(server.contratosiusa, {}, this.token)
                    ).then(res => {
                    this.syncronizaRecursive(0, res.data);         
                }).catch(err => {
                    this.isSyncronizando = false;
                    handledError(err, server.contratosiusa, this.$router, this.$store);
                })
            },
            syncronizaRecursive(idx, contratos){
                if(contratos[idx] == null ){
                    this.isSyncronizando = false; 
                }
                
                if( this.isSyncronizando){
                    axios(
                    getGetConfig(server2.ultrecibo, null, this.token, {clave: contratos[idx], tipoPadron:3})
                    ).then(() => {
                        this.estadoSyncIUSA = "Sincronizando "+(idx+1) + " de "+ contratos.length  ;
                        this.resultadoSyncIUSA += contratos[idx] + " sincronizado" + "\n";
                        this.syncronizaRecursive(idx+1, contratos);
                    }).catch(() => {            
                        //this.isSyncronizando = false;  
                        //handledError(err, server.contratosiusa, this.$router, this.$store);
                        this.estadoSyncIUSA = "Sincronizando "+(idx+1) + " de "+ contratos.length  ;
                        this.resultadoSyncIUSA += contratos[idx] + " sincronizado (ERROR ***)" + "\n";
                        this.syncronizaRecursive(idx+1, contratos);
                    }
                    )
                }
            },
            getLiquidacionTarjeta(){
                this.cleanResults();
                if(!this.isCalculando && !this.isGenerando && checkAuth(this.$router, this.$store)){
                    this.$store.commit("updateIsCalculando", true);
                    this.$store.commit("updateidxUltParcialidad", 999); //Siempre para una nueva peticion
                    
                    this.$store.commit("cleanFormsModels");
                    //this.$store.commit("updateFormModel", null); //se pone a null para que no aparezcan botones de exentar pago o funciones de cobro

                    
                    const solicitud = {
                            "servicio" : this.catalogCobro.wsAutoGestion,
                            "codigo" : this.codigoIUSA,
                            "usuario" : this.usuarioIUSA,
                            "pass" : this.passIUSA,
                            "emisor" : "",
                            "referencia" : "",
                            "formaPago" : 1,
                            "montoConfirmado" : -1
                        }

                    axios(
                        
                        getPostConfig(server.pagotarjetaiusa, solicitud, this.token, {})
                        
                    )
                    .then(res => {
                        const data = JSON.parse(res.data);

                        if(data.length <2){
                            alert(data[0])
                        }else{
                            this.$store.commit("updateDatosPago", data[0]);
                            this.$store.commit("updateParcialidades", data[1]);
                            this.$store.commit("updateTotalLiquidacion", data[2]);
                            this.$store.commit("updateResumenLiquidacion", data[3]);
                            this.$store.commit("updateSubsidiosAplicados", data[4]);   
                            
                            this.totalAPagar = parseFloat(data[2]);
                        }

                        this.$store.commit("updateIsCalculando", false);
                        //this.$store.commit("updateIsLiqFormCollapse", true);
                        navTo('liqTableOptions');
                        
                    }).catch(err => {
                        this.$store.commit("updateIsCalculando", false);
                        handledError(err, server.pagotarjetaiusa, this.$router, this.$store);
                    });
                }
            },
            cobrarLiquidacionTarjeta(){

                this.formaPagoIUSA =  this.formaPagoIUSA==null ||  this.formaPagoIUSA == '' ? 1 :  this.formaPagoIUSA;

                //Leemos antes de borrar los datos
                const solicitud = {
                            "servicio" : this.catalogCobro.wsAutoGestion,
                            "codigo" : this.codigoIUSA,
                            "usuario" : this.usuarioIUSA,
                            "pass" : this.passIUSA,
                            "emisor" : "",
                            "referencia" : "",
                            "formaPago" : this.formaPagoIUSA,
                            "montoConfirmado" : this.totalAPagar,
                            "cuenta":this.datosPago[0].detalle
                        }
                const cuenta = this.datosPago[0].detalle

                this.isShowConfirmacionCobro=false;
                this.cleanResults();
                this.formaPagoIUSA = '';
                if(!this.isCalculando && !this.isGenerando && checkAuth(this.$router, this.$store)){
                    this.$store.commit("updateIsCobrando", true);
                    this.$store.commit("updateidxUltParcialidad", 999); //Siempre para una nueva peticion
                    
                    this.$store.commit("cleanFormsModels");
                    //this.$store.commit("updateFormModel", null); //se pone a null para que no aparezcan botones de exentar pago o funciones de cobro
                    
                    axios(
                        getPostConfig(server.pagotarjetaiusa, solicitud, this.token, {})
                    )
                    .then(res => {
                        const data = JSON.parse(res.data);

                        if(data.length ==0){
                            
                            axios(
                                getGetConfig(server.ultrecibo, {}, this.token, {tipoPadron:3, clave:cuenta})
                            )
                            .then(res => {
                                this.$store.commit("clearResultsCobro");
                                this.$store.commit("updatePdfsGenerated", res.data);
                                this.$store.commit("updateIsShowModalCobro", true);
                                this.$store.commit("updateIsCobrando", false);
                                
                            }).catch(err => {
                                this.$store.commit("updateIsCobrando", false);
                                handledError(err, server.ultrecibo, this.$router, this.$store);
                            });

                        }else{
                            this.$store.commit("updateIsCobrando", false);
                            alert(data[0])
                        }

                        
                        //this.$store.commit("updateIsLiqFormCollapse", true);
                        
                    }).catch(err => {
                        this.$store.commit("updateIsCobrando", false);
                        handledError(err, server.pagotarjetaiusa, this.$router, this.$store);
                    });
                }
            },
            cleanResults (){
                if(!this.isCalculando & !this.isGenerando ){
                    this.$store.commit("clearResultsCobro");
                }
            },
            calculaCambio(){
                var totalCobro = this.totalLiquidacion.replace(',','');
                this.cambioDinero = this.dineroRecibido.replace(',','') - totalCobro;
            },
            showConfirmacionCobro(){
                this.dineroRecibido = '';
                this.isShowConfirmacionCobro=true
            }
        },
       
    }
</script>
<style>
div.error    {color: red;}
</style>